/**
 * Actions for add new
 */
export const actions = {
  /**
   * Fetch timezones from server
   * @param {Object} context
   */
  async getTimezones(context) {
    // Only fetch data if not fetched before
    if (context.getters.getTimezones.length === 0) {
      // Start loading
      context.commit("startLoading");

      // Fetching timezones data
      const json = await context.dispatch(
        "makeAuthRequest",
        {
          url: "timezone/get",
          method: "GET"
        },
        { root: true }
      );

      // If timezones have been sent
      if ("timezones" in json) {
        context.commit("setTimezoneOptions", json.timezones); // Set timezones in state
      }

      // If state codes have been sent
      if ("state_codes" in json) {
        context.commit("setStateCodes", json.state_codes); // Set state codes in state
      }

      // Stop loading
      context.commit("stopLoading");
    }
  },
  /**
   * Get the insurance details of the provider id
   * @param {Object} context
   */
  async getInsuranceDetails(context) {
    //  Step 0: Getting the selected provider id
    const selectedProviderId = context.rootGetters.getSelectedProviderID;

    // Only fetch data if not fetched before
    if (!(selectedProviderId in context.getters.getInsuranceCompanies)) {
      // Start loading
      context.commit("startLoading");

      // Fetching timezones data
      const json = await context.dispatch(
        "makeAuthRequest",
        {
          url: `insurance/get/${selectedProviderId}`,
          method: "GET"
        },
        { root: true }
      );

      // Adding insurance companies details to the state
      if ("insuranceCompanyDetails" in json) {
        context.commit("setInsuranceCompanies", {
          id: selectedProviderId,
          companies: json.insuranceCompanyDetails
        });
      }

      // Stop loading
      context.commit("stopLoading");
    }
  }
};
